import { render, staticRenderFns } from "./InstallColumn.vue?vue&type=template&id=cd3aaf74"
import script from "./InstallColumn.vue?vue&type=script&lang=js"
export * from "./InstallColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports